import { useQuery } from '@tanstack/react-query';

import { getDevice } from '~/utils/getDevice';

export const useDeviceQuery = () =>
  useQuery({
    cacheTime: Infinity,
    queryFn: getDevice,
    queryKey: ['user-agent'],
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
